import React from 'react'
import PropTypes from 'prop-types'
import {
    Box,
    useMultiStyleConfig
} from '@salesforce/retail-react-app/app/components/shared/ui'

/* Utils */
import { renderComponentsSwitch } from '../../utils/contentRenderer'

const WebFooterTopBarBlock = ({
    Items
}) => {
    const styles = useMultiStyleConfig('WebFooterTopBarBlock')

    return (
        <Box {...styles.featuresLinksContainer}>
            {Items?.map((WebFooterTopBarColumnBlock, index) => {
                const showDivider = Items.length !== (index + 1)
                return <React.Fragment key={`WebFooterTopBarBlock-${index}`}>
                    {renderComponentsSwitch(WebFooterTopBarColumnBlock?.Expanded, { showDivider: showDivider })}
                </React.Fragment>
            })}
        </Box>
    )
}

WebFooterTopBarBlock.propTypes = {
    Items: PropTypes.arrayOf(PropTypes.shape({}))
}

export default WebFooterTopBarBlock
